import { Flex, Text } from '@chakra-ui/react';
import { RiFlashlightLine } from 'react-icons/ri';
import { HelivanColor } from './HelivanColor';

const BetaTag = () => {
  return (
    <Flex
      alignItems="center"
      gap="4px"
      bg="linear-gradient(135deg, rgba(0,71,125,0.08) 0%, rgba(0,71,125,0.15) 100%)"
      border="1px solid"
      borderColor="rgba(0,71,125,0.2)"
      borderRadius="full"
      px="10px"
      py="3px"
      transition="all 0.2s ease"
      _hover={{
        bg: 'linear-gradient(135deg, rgba(0,71,125,0.12) 0%, rgba(0,71,125,0.2) 100%)',
        borderColor: HelivanColor.text.helivanBlue,
      }}
    >
      <RiFlashlightLine size={11} color={HelivanColor.text.helivanBlue} />
      <Text
        fontSize="10px"
        fontWeight={600}
        color={HelivanColor.text.helivanBlue}
        letterSpacing="0.5px"
        textTransform="uppercase"
        lineHeight="1"
      >
        Beta
      </Text>
    </Flex>
  );
};

export default BetaTag;
